import * as constants from "../../constants";
import clientApi from "../../api/client.api";

const refreshInterval = 1000 * 60 * 60 * 3; // 3 hours

function getState() {
    return {
        items : [],
        status: constants.RESOURCE_STATUS_NOT_LOADED,
    }
}

function fetchClients(commit) {
    return clientApi.all().then(({data}) => {
        commit('SET_ITEMS', data.data);
    }).finally(() => {
        commit('SET_STATUS', constants.RESOURCE_STATUS_LOADED);
    });
}

const state = getState();

const getters = {};

const actions = {
    init({commit}) {
        commit('SET_STATUS', constants.RESOURCE_STATUS_LOADING);
        setInterval(fetchClients, refreshInterval, commit);
        return fetchClients(commit);
    },
    update({commit}, {id, data}) {
        return clientApi.update(id, data).then((response) => {
            commit('UPDATE_ITEM', {id, data: response.data.data});
            return response;
        });
    },
    remove({commit}, id) {
        return clientApi.delete(id).then(() => {
            commit('REMOVE_ITEM', id);
        })
    },
    add({commit}, data) {
        return clientApi.create(data).then((response) => {
            commit('ADD_ITEM', response.data.data);
            return response;
        });
    },
    refresh({commit}) {
        return fetchClients(commit);
    },
};

const mutations = {
    SET_ITEMS(state, items) {
        state.items = items;
    },
    SET_STATUS(state, value) {
        state.status = value;
    },
    ADD_ITEM(state, item) {
        state.items.unshift(item);
    },
    UPDATE_ITEM(state, {id, data}) {
        const index = state.items.findIndex(item => item.id == id);
        if (-1 !== index) {
            const newItem = Object.assign({}, state.items[index], data);
            state.items.splice(index, 1, newItem);
        }
    },
    REMOVE_ITEM(state, id) {
        state.items.splice(state.items.findIndex(item => item.id == id), 1);
    },
    UPDATE_CARD(state, card) {
        const clientIndex = state.items.findIndex(item => -1 !== item.active_cards.findIndex(clientCard => clientCard.id === card.id));
        if (-1 === clientIndex) {
            return;
        }

        const cardIndex = state.items[clientIndex].active_cards.findIndex(clientCard => clientCard.id === card.id);
        if (-1 === cardIndex) {
            return;
        }

        state.items[clientIndex].active_cards[cardIndex] = Object.assign(state.items[clientIndex].active_cards[cardIndex], card);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
